import React, { Component } from 'react'
import { Button } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'
import { api as sfdcApi } from 'app/modules/sfdc/api'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import SalesforceLeadRouting from 'components/settings/Rules/components/FilterEditor/SalesforceFilter/containers/SalesforceLeadRouting'

import './style.styl'

class SalesforceRoutingSettings extends Component {
  constructor(props) {
    super(props)
    this.state = { changesMade: false }
  }


  onSalesforceLeadRoutingSettingsUpdated = (settings) => {

    // skip storing changesMade for intial load
    if (this.state.selectedSalesforceLeadRoutingSettings) {
      this.setState({ changesMade: true })
    }
    this.setState({ selectedSalesforceLeadRoutingSettings: settings })
  }

  publishSFDCSettings = () => {
    const { selectedSalesforceLeadRoutingSettings } = this.state
    if (selectedSalesforceLeadRoutingSettings) {
      sfdcApi.patchSalesforceLeadRoutingSettings({ settings: selectedSalesforceLeadRoutingSettings })
    }
  }

  render() {
    const { selectedSalesforceLeadRoutingSettings, changesMade } = this.state

    return (
      <div className="common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Salesforce Integration"
          backLinkUrl="/settings/setup/salesforce"
        />
        <header>
          <h2 className="integration-header">Salesforce Conversation Routing Settings</h2>
        </header>
        <div className="salesforce-routing-ui">
        <p>When a known user chats in to Drift, we’ll use their email to see if they exist in
        Salesforce and will find the appropriate owner in cascading order.</p>
          <div className="rules-salesforce-filter rules-choice">
              <div className="rules-editor-content">
                <div className="rules-choice-content drift-form">
                  <SalesforceLeadRouting
                    onSalesforceLeadRoutingSettingsUpdated={this.onSalesforceLeadRoutingSettingsUpdated}
                    selectedSalesforceLeadRoutingSettings={this.state.selectedSalesforceLeadRoutingSettings}/>
                </div>
              </div>
          </div>
        </div>
        <div className="salesforce-routing-save-button-container">
          {
            changesMade &&
            <Link
            className="salesforce-routing-cancel-button"
            to="/settings/setup/salesforce">Cancel</Link>
          }
          <Button
            className="salesforce-routing-save-button"
            type="primary"
            onClick={this.publishSFDCSettings}
            disabled={!this.state.selectedSalesforceLeadRoutingSettings}>Save changes</Button>
        </div>
      </div>
    )
  }
}

export default SalesforceRoutingSettings



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceRoutingSettings/index.js